const getOperatorUsers = (state) => {
  return state.main.operatorUserState.operatorUsers
}

const getInviteOperatorUsers = (state) => {
  return state.main.operatorUserState.inviteOperatorUsers
}

const getFetchOperatorUserListRequestState = (state) => {
  return state.main.operatorUserState.fetchOperatorUserListRequestState
}

const getOperatorUsersPagination = (state) => {
  return state.main.operatorUserState.operatorUsersPagination
}

const getOperatorUsersFilters = (state) => {
  return state.main.operatorUserState.operatorUsersFilter
}

const getUpdateOperatorUserListRequestState = (state) => {
  return state.main.operatorUserState.updateOperatorUserListRequestState
}

const getInviteOperatorUserRequestState = (state) => {
  return state.main.operatorUserState.inviteOperatorUserRequestState
}

const getFetchInviteOperatorUserListRequestState = (state) => {
  return state.main.operatorUserState.fetchInviteOperatorUserListRequestState
}

const getDeleteOperatorUserRequestState = (state) => {
  return state.main.operatorUserState.deleteOperatorUserRequestState
}

const getDeleteInviteOperatorUserRequestState = (state) => {
  return state.main.operatorUserState.deleteInviteOperatorUserRequestState
}

const getSendOperatorUserEmailRequestState = (state) => {
  return state.main.operatorUserState.sendOperatorUserEmailRequestState
}

const getFetchInviteOperatorUserRequestState = (state) => {
  return state.main.operatorUserState.fetchInviteOperatorUserRequestState
}

const getInviteOperatorUser = (state) => {
  return state.main.operatorUserState.inviteOperatorUser
}

const getCreateOperatorUserRequestState = (state) => {
  return state.main.operatorUserState.createOperatorUserRequestState
}

const getInviteOperatorUserStatus = (state) => {
  return state.main.operatorUserState.inviteOperatorUserStatus
}
const getTariffsList = (state) => {
  return state.main.operatorUserState.tariffsList
}

const getFetchTariffListRequestState = (state) => {
  return state.main.operatorUserState.fetchTariffListRequestState
}

const getPrivacySchedule = (state) => {
  return state.main.operatorUserState.privacySchedule
}

const getFetchPrivacyScheduleRequestState = (state) => {
  return state.main.operatorUserState.fetchPrivacyScheduleRequestState
}
const getAccessGroupsList = (state) => {
  return state.main.operatorUserState.accessGroupsList
}

const getFetchAccessGroupsListRequestState = (state) => {
  return state.main.operatorUserState.fetchAccessGroupsListRequestState
}
const getInviteOperatorUsersPagination = (state) => {
  return state.main.operatorUserState.inviteOperatorUsersPagination
}

const getFetchOperatorUsersInvitationsCountRequestState = (state) => {
  return state.main.operatorUserState
    .fetchOperatorUsersInvitationsCountRequestState
}
const getFetchOperatorUsersCountRequestState = (state) => {
  return state.main.operatorUserState.fetchOperatorUsersCountRequestState
}
const getOperatorUsersCount = (state) => {
  return state.main.operatorUserState.operatorUsersCount
}
const getOperatorUsersInvitationsCount = (state) => {
  return state.main.operatorUserState.operatorUsersInvitationsCount
}
const getChangePasswordOrNameRequestState = (state) => {
  return state.main.operatorUserState.changePasswordOrNameRequestState
}
const getUpdateOperatorUserRequestState = (state) => {
  return state.main.operatorUserState.updateOperatorUserRequestState
}
const getClickedOperatorUser = (state) => {
  return state.main.operatorUserState.clickedOperatorUser
}
const getOperatorUsersAlertEmails = (state) => {
  return state.main.operatorUserState.operatorUsersAlertEmails
}
const OperatorUserSelectors = {
  getOperatorUsers,
  getInviteOperatorUsers,
  getFetchOperatorUserListRequestState,
  getUpdateOperatorUserListRequestState,
  getInviteOperatorUserRequestState,
  getFetchInviteOperatorUserListRequestState,
  getDeleteOperatorUserRequestState,
  getDeleteInviteOperatorUserRequestState,
  getSendOperatorUserEmailRequestState,
  getFetchInviteOperatorUserRequestState,
  getInviteOperatorUser,
  getCreateOperatorUserRequestState,
  getInviteOperatorUserStatus,
  getTariffsList,
  getFetchTariffListRequestState,
  getPrivacySchedule,
  getFetchPrivacyScheduleRequestState,
  getAccessGroupsList,
  getFetchAccessGroupsListRequestState,
  getInviteOperatorUsersPagination,
  getOperatorUsersPagination,
  getOperatorUsersFilters,
  getFetchOperatorUsersInvitationsCountRequestState,
  getFetchOperatorUsersCountRequestState,
  getOperatorUsersCount,
  getOperatorUsersInvitationsCount,
  getChangePasswordOrNameRequestState,
  getUpdateOperatorUserRequestState,
  getClickedOperatorUser,
  getOperatorUsersAlertEmails,
}

export default OperatorUserSelectors
